var _path, _path2, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateCreateIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eSrGJYjvNsW1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 1200",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "e3046d79211a43abb2c8d8e111b7fbe8",
    "export-id": "3a33844af122431ca6aa7b2ed187004d",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220,230C405,65,690,25,955,65s462,170,655,273c145,77,187,241,40,352C1342,921,495,945,200,743C56,645,84,433,220,230Z",
    transform: "matrix(.919251 0 0 1-20.474187 140)",
    fill: "#f4f9fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220,230C405,65,690,25,955,65s462,170,655,273c145,77,187,241,40,352C1342,921,495,945,200,743C56,645,84,433,220,230Z",
    transform: "matrix(.919251 0 0 1-20.474187 140)",
    opacity: 0.08,
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(800 640)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 340,
    ry: 46,
    transform: "translate(0 260)",
    opacity: 0.1,
    fill: "#0b3755"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 520,
    rx: 16,
    ry: 16,
    transform: "translate(-360-260)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 520,
    rx: 16,
    ry: 16,
    transform: "translate(-360-260)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 88,
    rx: 28,
    ry: 28,
    transform: "translate(-360-260)",
    fill: "#e9f3fb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 88,
    rx: 16,
    ry: 16,
    transform: "translate(-360-260)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 6,
    ry: 6,
    transform: "translate(-300-140)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 40,
    rx: 6,
    ry: 6,
    transform: "translate(40-140)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 28,
    rx: 6,
    ry: 6,
    transform: "translate(40-86)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 22,
    rx: 6,
    ry: 6,
    transform: "translate(40-32)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 22,
    rx: 6,
    ry: 6,
    transform: "translate(40 6)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 22,
    rx: 6,
    ry: 6,
    transform: "translate(40 44)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 46,
    rx: 6,
    ry: 6,
    transform: "translate(-300 76)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 46,
    rx: 6,
    ry: 6,
    transform: "matrix(.908674 0 0 1-125.38784 76)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10,12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -320,
    y1: -176,
    x2: 320,
    y2: -176,
    opacity: 0.06,
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -320,
    y1: 120,
    x2: 320,
    y2: 120,
    opacity: 0.06,
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -320,
    y1: -8,
    x2: 320,
    y2: -8,
    opacity: 0.06,
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340 560)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    rx: 8,
    ry: 8,
    transform: "translate(-120-80)",
    fill: "#12f0e5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    rx: 8,
    ry: 8,
    transform: "translate(-120-80)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 96,
    rx: 8,
    ry: 8,
    transform: "translate(-88-48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 96,
    rx: 4,
    ry: 4,
    transform: "translate(-88-48)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 14,
    transform: "translate(0-20)",
    fill: "#12f0e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76,30l40-38L-4,18l34-30L76,30h-152Z",
    fill: "#12f0e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76,30l40-38L-4,18l34-30L76,30h-152Z",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30c90,10,160,30,240-20",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382,10 360,20 366,-2",
    transform: "matrix(-.981012-.193948 0.193948-.981012 742.209883 87.708221)",
    fill: "#0b3755"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260 680)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 136,
    rx: 8,
    ry: 8,
    transform: "translate(-110-68)",
    fill: "#fe84f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 136,
    rx: 8,
    ry: 8,
    transform: "translate(-110-68)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 18,
    rx: 9,
    ry: 9,
    transform: "translate(-82-36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 18,
    rx: 9,
    ry: 9,
    transform: "translate(-82-10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 18,
    rx: 9,
    ry: 9,
    transform: "translate(-82 16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140,-6c-80,26-150,46-210,16",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.986704 0.162528-.162528-.986704-687.644836 70.943959)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-352,10 -329.50088,23.12264 -336,-2",
    fill: "#0b3755"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(800 1020)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 112,
    rx: 22,
    ry: 22,
    transform: "translate(-130-56)",
    fill: "#14b3eb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 112,
    rx: 22,
    ry: 22,
    transform: "translate(-130-56)",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 22,
    rx: 11,
    ry: 11,
    transform: "translate(-98-20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 22,
    rx: 11,
    ry: 11,
    transform: "translate(-98 14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-70c0-60,60-100,120-140",
    fill: "none",
    stroke: "#0b3755",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120,-210 104,-188 130,-190",
    transform: "matrix(-.971698 0.236225-.236225-.971698 191.526955-431.006279)",
    fill: "#0b3755"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateCreateIcon3);
export default __webpack_public_path__ + "static/media/template-create-icon3.888c263aa483336f9ec26e24df2197bb.svg";
export { ForwardRef as ReactComponent };